import { uiSurface } from "shared/ui/uiSurface"
import { Box, Collapse, Paper, Stack } from "@mui/material"
import { FC, memo, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useOrderContex } from "src/app/context"
import { useAppDispatch, useAppSelector } from "src/app/hooks"
import { filterOrderDetail } from "src/app/slices/dashboard.slice"
import { AutocompleteWrapper } from "src/features/shared-module/components"
import { getFullName } from "src/features/shared-module/functions"
import { useOrderFilter } from "../hooks"
import { CommonSorting, CommonQueryFilter } from "./CommonQueryFilter"
import { OrderStatusEnum } from "src/features/shared-module/constants"

interface MainOrderFilterSectionProps {}

export const MainOrderFilterSection: FC<MainOrderFilterSectionProps> = memo(
  () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const { isFilterExpanded } = useOrderContex()

    const haulerEmployeeMasterList = useAppSelector(
      (state) => state.dashboard.employeeMasterList,
    )

    const haulerList = useAppSelector((state) => {
      return state.dashboard.haulerList
    })

    const { filterState: employeeFilter, actions } = useOrderFilter()

    useEffect(() => {
      dispatch(filterOrderDetail(employeeFilter as any))
    }, [dispatch, employeeFilter])
    return (
      <Collapse in={isFilterExpanded}>
        <Paper
          {...uiSurface("UI-DSP-030")}
          data-testid="employee-filter-panel"
          variant="outlined"
          sx={{
            marginTop: 0.5,
            padding: 1,
          }}
        >
          <Box
            sx={{
              marginBottom: 1,
            }}
          >
            <AutocompleteWrapper
              data-testid="employee-filter-state"
              multiple
              size="small"
              value={employeeFilter.stateList}
              onChange={actions.setOrderStateList}
              placeholder={t("filterByOrderState")}
              name="state-search-input"
              margin="none"
              options={[
                OrderStatusEnum.ON_THE_WAY_TO_CUSTOMER,
                OrderStatusEnum.ON_THE_WAY_TO_PROVIDER,
                OrderStatusEnum.COMPLETED,
              ].map((state) => {
                return {
                  label: t(state),
                  value: state,
                }
              })}
            />
          </Box>
          <Stack
            spacing={1}
            direction={"row"}
            marginBottom={1}
            sx={{
              "& .MuiAutocomplete-root": {
                width: "50%",
              },
            }}
          >
            <AutocompleteWrapper
              data-testid="employee-filter-employee"
              multiple
              size="small"
              value={employeeFilter.haulerEmployeeIds}
              onChange={actions.setHaulerEmployeeIds}
              placeholder={t("filterByEmployeeName")}
              name="search-emp-input"
              margin="none"
              options={haulerEmployeeMasterList.map((e) => {
                return {
                  label: getFullName(e.firstName, e.lastName),
                  value: e.id,
                }
              })}
            />
            <AutocompleteWrapper
              data-testid="employee-filter-hauler"
              multiple
              size="small"
              value={employeeFilter.haulerIds}
              onChange={actions.setHaulerIds}
              placeholder={t("filterByHaulerName")}
              name="search-hauler-input"
              margin="none"
              options={haulerList.map((e) => {
                return {
                  label: e.name,
                  value: e.id,
                }
              })}
            />
          </Stack>
          <Stack direction={"row"} spacing={1}>
            <CommonQueryFilter
              initialQuery={employeeFilter.query}
              onChangeQuery={actions.setFilterQuery}
            />
            <CommonSorting
              options={["id"].map((e) => {
                return {
                  label: t("sortByEmployeeName"),
                  value: "employeeName",
                }
              })}
              onChangeSort={(value: string) =>
                actions.setSorting({ sortBy: value, sortOrder: "asc" })
              }
            />
          </Stack>
        </Paper>
      </Collapse>
    )
  },
)
